import { SelectFields } from '@repo/toolkit/types'

import { EnrollmentIdentity } from '../../lib/types/models/enrollment/enrollment-identity'
import { FieldsSelector } from '../../lib/types/utils'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getEnrollmentIdentity<T extends FieldsSelector<EnrollmentIdentity>>(
  id: number,
  fields: T
) {
  return restApiClient
    .url(
      encodeNestedObject(constructApiUrl(API.enrollments.getEnrollmentIdentity.url, { id }), {
        fields
      })
    )
    .get<SelectFields<EnrollmentIdentity, T>>()
}
